// eslint-disable-next-line import/prefer-default-export
export const OTEL_AUTO_INSTRUMENTS_SPANS = "auto-instrumentation-spans";
